"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderSellerShippingPrice = void 0;
var react_1 = __importStar(require("react"));
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var client_1 = require("@apollo/client");
var UseSellerShippingPrice_1 = require("./UseSellerShippingPrice");
var SellerShippingPrice_1 = __importDefault(require("./SellerShippingPrice"));
var react_dom_1 = __importDefault(require("react-dom"));
var QUERY = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query SellerShippingPriceLoaderQuery($sellerContactId: String, $overseas: Boolean) {\n    calculateSellerShippingPrice {\n      calculateSellerShippingPrice(sellerContactId: $sellerContactId, overseas: $overseas) {\n        locations {\n          locationCode\n          locationName\n          baseShippingFees {\n            locationCode\n            locationName\n            priceFrom\n            priceTo\n            shippingFee\n          }\n          additionalShippingFeesWeight {\n            locationCode\n            locationName\n            referenceWeight\n            shippingFee\n            shippingFeePerAdditionalKilo\n            shippingPlanDisplayId\n          }\n          additionalShippingFeesQuantity {\n            locationCode\n            locationName\n            shippingFee\n            shippingFeePerAdditionalQuantity\n            shippingPlanDisplayId\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query SellerShippingPriceLoaderQuery($sellerContactId: String, $overseas: Boolean) {\n    calculateSellerShippingPrice {\n      calculateSellerShippingPrice(sellerContactId: $sellerContactId, overseas: $overseas) {\n        locations {\n          locationCode\n          locationName\n          baseShippingFees {\n            locationCode\n            locationName\n            priceFrom\n            priceTo\n            shippingFee\n          }\n          additionalShippingFeesWeight {\n            locationCode\n            locationName\n            referenceWeight\n            shippingFee\n            shippingFeePerAdditionalKilo\n            shippingPlanDisplayId\n          }\n          additionalShippingFeesQuantity {\n            locationCode\n            locationName\n            shippingFee\n            shippingFeePerAdditionalQuantity\n            shippingPlanDisplayId\n          }\n        }\n      }\n    }\n  }\n"])));
var SellerShippingPriceLoader = function (props) {
    var _a = client_1.useQuery(QUERY, {
        variables: {
            sellerContactId: props.sellerContactId,
            overseas: props.overseas == 'true',
        },
    }), loading = _a.loading, error = _a.error, data = _a.data, refetch = _a.refetch, fetchMore = _a.fetchMore;
    var _b = UseSellerShippingPrice_1.useSellerShippingPrice(), updateLocations = _b.updateLocations, tableConfig = _b.tableConfig;
    react_1.useEffect(function () {
        if (data &&
            data.calculateSellerShippingPrice &&
            data.calculateSellerShippingPrice.calculateSellerShippingPrice &&
            data.calculateSellerShippingPrice.calculateSellerShippingPrice.locations) {
            updateLocations(data.calculateSellerShippingPrice.calculateSellerShippingPrice.locations);
        }
    }, [data]);
    if (loading)
        return react_1.default.createElement("div", null, "Loading");
    if (error)
        return react_1.default.createElement("div", null, error.message);
    return react_1.default.createElement(SellerShippingPrice_1.default, { tableConfig: tableConfig });
};
var renderSellerShippingPrice = function (apolloClient) {
    var itemShippingFeeListComponent = document.getElementById('aperza-item-shipping-fees-component');
    if (itemShippingFeeListComponent) {
        var sellerContactId = itemShippingFeeListComponent.dataset.sellerContactId;
        var overseas = itemShippingFeeListComponent.dataset.overseas;
        var lang = itemShippingFeeListComponent.dataset.lang;
        react_dom_1.default.render(react_1.default.createElement(client_1.ApolloProvider, { client: apolloClient },
            react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null) },
                react_1.default.createElement(SellerShippingPriceLoader, { sellerContactId: sellerContactId, overseas: overseas, lang: lang }))), itemShippingFeeListComponent);
        // ReactDOM.render(<ItemShippingFeeListComponent sellerContactId={sellerContactId} overseas={overseas} lang={lang}/>, itemShippingFeeListComponent);
    }
};
exports.renderSellerShippingPrice = renderSellerShippingPrice;
var templateObject_1;
